import { checkIsVirtualKeyboardOpened } from '$setup/visual-viewport'
import { useEffect, useState } from 'react'

export function useWindowHeight() {
  const [height, setHeight] = useState(window.innerHeight)

  useEffect(() => {
    let pendingVhUpdate = false
    const onResize = () => {
      if (pendingVhUpdate) return
      pendingVhUpdate = true

      requestAnimationFrame(() => {
        pendingVhUpdate = false
        if (!window.visualViewport) {
          setHeight(window.innerHeight)
          return
        }
        const isVirtualKeyboardOpened = checkIsVirtualKeyboardOpened()
        const sab = getComputedStyle(document.documentElement).getPropertyValue(
          '--safe-area-inset-bottom',
        )
        const sat = getComputedStyle(document.documentElement).getPropertyValue(
          '--safe-area-inset-top',
        )

        const newHeight = isVirtualKeyboardOpened
          ? window.visualViewport.height - parseFloat(sat || '0')
          : window.visualViewport.height -
            parseFloat(sab || '0') -
            parseFloat(sat || '0')

        setHeight(newHeight)
      })
    }
    window.addEventListener('resize', onResize)
    onResize()

    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onResize)
      window.visualViewport.addEventListener('resize', onResize)
    }

    return () => {
      window.removeEventListener('resize', onResize)
      window.visualViewport?.removeEventListener('scroll', onResize)
      window.visualViewport?.removeEventListener('resize', onResize)
    }
  }, [])

  return height
}
